import React from 'react';

function KnowledgeBase() {
  return (
    <div className="border p-4">
      <h2 className="text-xl font-bold mb-2">Knowledge Base</h2>
      <p>This could display your NC estate statutes, template names, etc.</p>
      <ul className="list-disc list-inside mt-2">
        <li>Will Template: WillTemplateV1.docx</li>
        <li>Trust Template: RevocableTrustTemplateV2.docx</li>
        <li>Statutes: NCGS Chapter 31, 36C, etc.</li>
      </ul>
    </div>
  );
}

export default KnowledgeBase;